import React, { useContext, useEffect, useState } from 'react';
import { graphql, PageProps, HeadProps } from 'gatsby';
import { SEO } from '../../components/Seo';
import { Kfh_ContentPageUmbracoType, Kfh_ContentStandardWideType } from '../../types/graphqlTypes';
import { ComponentRenderer } from '../../components/componentRenderer/ComponentRenderer';
import { PageHeader } from '../../components/pageHeader/PageHeader';
import { StickyValuationBar } from '../../components/StickyValuationBar';
import { UiStateContext } from '../../context/UiStateContext';
import { useExperiments } from '../../context/ExperimentsContext';
import { isBrowser } from '../../utils';
import { Loader } from '../../components/Loader';
import { Section } from '../../components/Section';

interface StandardWidePageProps {
  page: Kfh_ContentPageUmbracoType;
  buyersTestPage: Kfh_ContentPageUmbracoType;
}

const StandardWidePage = ({ data }: PageProps<StandardWidePageProps>) => {
  const { heroOutOfView } = useContext(UiStateContext);
  const isSellers = data.page.relativeUrl.includes('/sellers');
  const isLandlords = data.page.relativeUrl.includes('/landlords');
  const [pageContent, setPageContent] = useState<Kfh_ContentPageUmbracoType>(data.page);
  const { experiments } = useExperiments();
  const isTestVariation = experiments?.KFH24009 === 'variation';

  useEffect(() => {
    if (data.page.relativeUrl === '/buyers/' && isTestVariation && data.buyersTestPage) {
      setPageContent(data.buyersTestPage);
    }
  }, [data.buyersTestPage, data.page.relativeUrl, isTestVariation]);

  const { layout } = pageContent;
  const { pageHeader, regions } = layout as unknown as Kfh_ContentStandardWideType;

  // Regions

  const wideRegion = regions?.filter((region) => region.regionType === 'Wide')[0];

  return (
    <>
      {/* SEO */}

      {/* Page header / hero */}

      {pageHeader && <PageHeader pageHeader={pageHeader} />}

      {/* Regions and Components */}

      {wideRegion?.components ? <ComponentRenderer components={wideRegion?.components} width="wide" /> : <Section />}

      {heroOutOfView && (isLandlords || isSellers) && <StickyValuationBar />}
    </>
  );
};

export default StandardWidePage;

export const Head = ({ data }: HeadProps<StandardWidePageProps>) => {
  const { seoSettings, feed } = data.page;
  return (
    <SEO
      data={seoSettings}
      image={feed?.featuredImage?.localFile?.resize?.src ? feed.featuredImage.localFile.resize.src : undefined}
    />
  );
};

export const pageQuery = graphql`
  query StandardWidePageQuery($id: String!) {
    page: kfhContentPageUmbracoType(id: { eq: $id }) {
      pageName
      relativeUrl
      seoSettings {
        ...SEO
      }
      feed {
        featuredImage {
          ...PageSocialImage
        }
      }
      classification {
        audiences
        services
      }
      layout {
        ... on KFH_ContentStandardWideType {
          pageHeader {
            ...PageHeader
          }
          regions {
            ...ComponentRegions
          }
        }
      }
    }
    buyersTestPage: kfhContentPageUmbracoType(pageName: { eq: "buyers-test" }) {
      pageName
      seoSettings {
        ...SEO
      }
      layout {
        ... on KFH_ContentStandardWideType {
          pageHeader {
            ...PageHeader
          }
          regions {
            ...ComponentRegions
          }
        }
      }
    }
  }
`;
